import api from "../../utils/apiPublic";

export const validateCart = async (cart) => {
  const res = await api.post("/api/cart/validate", {
    items: cart.map((item) => ({
      producto_id: item.producto_id,
      cantidad: item.cantidad,
    })),
  });

  return res.data;
};
